// extracted by mini-css-extract-plugin
export default {"container":"_4ae8be61","colorSelect":"_6d184f3","swatch":"_87d1a11c","selected":"_f397364f","disabled":"_6e2e21f6"};